import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: "en",
  resources: {
    en: {
      translations: require("./locales/en/translations.json"),
      quiz: require("./locales/en/quiz.json"),
      calendar: require("./locales/en/calendar.json"),
      scrapbook: require("./locales/en/scrapbook.json"),
    },
    fr: {
      translations: require("./locales/fr/translations.json"),
      quiz: require("./locales/fr/quiz.json"),
      calendar: require("./locales/fr/calendar.json"),
      scrapbook: require("./locales/fr/scrapbook.json"),
    },
  },
  ns: ["translations", "quiz", "calendar", "scrapbook"],
  defaultNS: "translations",
  returnObjects: true,
});

export default i18n;
